// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__34Rc5","left":"InfoRow_left__1MqI6"};